"use client";
import ProjectSlider from "./ProjectSlider";
import { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

const Ourwork = ({ projects }) => {
  const headerRef = useRef(null);
  const containerRef = useRef(null);
  useGSAP(
    () => {
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: -50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.5,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    },
    { scope: containerRef }
  );

  return (
    <main className="main_ourwork" ref={containerRef}>
      <div className="ourwork_header" ref={headerRef}>
        <h1 className={`header`}>Flowing Water, Living Spaces</h1>
        <p>
          ทุกสายน้ำที่ไหลเอื่อย ทุกก้อนหินที่จัดวาง
          <br />
          ล้วนเกิดจากความตั้งใจ
          ที่อยากให้สวนของคุณเป็นมุมเงียบสงบสำหรับการพักผ่อน
        </p>
      </div>

      <div>
        <ProjectSlider projects={projects} />
      </div>
    </main>
  );
};

export default Ourwork;
